<template>
    <div>
        <PCAboutUs 
            v-if=" getInfor && isMobile === false" 
            :infor="infor" 
        />
        <MobAboutUs 
            v-else-if=" getInfor && isMobile" 
            :infor="infor" 
        />
    </div>
</template>
<script>

    import PCAboutUs from '@/components/pc/PCAboutUs'
    import MobAboutUs from '@/components/mobile/MobAboutUs'

    // import jquery from 'jquery'

    import aboutUsJson from '@/json/about-us'

    export default {
        name: 'AboutUs',
        props: {
            isMobile: Boolean
        },
        components: {
            PCAboutUs,
            MobAboutUs
        },
        data: function(){
            return {
                infor: aboutUsJson,
                getInfor: true
            }
        },
        mounted() {

            // let _this = this;
            // window.getAjaxJson = {};
            // jquery.get('./json/about-us.js', function(){
            //    _this.infor =  window.getAjaxJson;
            //    _this.getInfor = true;
            // });
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*导航*/

</style>